import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type TruckDeliveryIconProps = CreateIconComponentProps;
export const TruckDeliveryIcon: React.FC<TruckDeliveryIconProps> = ({
  title = 'TruckDelivery',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <circle
      cx="7"
      cy="17"
      r="2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <circle
      cx="17"
      cy="17"
      r="2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      fill="currentColor"
      d="M5 18a1 1 0 1 0 0-2v2Zm-2-1H2a1 1 0 0 0 1 1v-1Zm1-4a1 1 0 1 0-2 0h2ZM2 4a1 1 0 0 0 0 2V4Zm11 1h1a1 1 0 0 0-1-1v1Zm-1 12a1 1 0 1 0 2 0h-2Zm-3-1a1 1 0 1 0 0 2v-2Zm6 2a1 1 0 1 0 0-2v2Zm4-2a1 1 0 1 0 0 2v-2Zm2 1v1a1 1 0 0 0 1-1h-1Zm0-6h1a1 1 0 0 0-1-1v1Zm-8-1a1 1 0 1 0 0 2v-2Zm0-5a1 1 0 1 0 0 2V5Zm5 1 .858-.514A1 1 0 0 0 18 5v1Zm2.142 5.514a1 1 0 0 0 1.716-1.028l-1.716 1.028ZM5 16H3v2h2v-2Zm-1 1v-4H2v4h2ZM2 6h11V4H2v2Zm10-1v12h2V5h-2ZM9 18h6v-2H9v2Zm10 0h2v-2h-2v2Zm3-1v-6h-2v6h2Zm-1-7h-8v2h8v-2Zm-8-3h5V5h-5v2Zm4.142-.486 3 5 1.716-1.028-3-5-1.716 1.029Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 9h4"
    />
  </CreateIconComponent>
);
